import { Image } from "antd";
import { useEffect } from "react";
const Expire = () => {
  useEffect(() => {
      document.title = "Note - Mon AI";
    }, []);
    
  return (
    <div className="min-h-screen flex justify-center items-center px-4 sm:px-0">
      <div className="w-full max-w-[360px] border border-[#f0f0f0] text-center p-6 rounded-lg">
        <div className="relative">
          <Image src="/images/expire.png" width={"130px"} alt="" preview={false} />
          <h1 className="text-[20px] font-bold my-4">Expired Session</h1>
          <p>The link has been expired. Please request a new one from the Mon AI user.</p>
        </div>
      </div>
    </div>
  );
};

export default Expire;
